import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=ecee8312&scoped=true"
import script from "./NewClientModal.vue?vue&type=script&lang=js"
export * from "./NewClientModal.vue?vue&type=script&lang=js"
import style0 from "./NewClientModal.vue?vue&type=style&index=0&id=ecee8312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee8312",
  null
  
)

export default component.exports